import React from 'react';
import { Button, Form, ModalBody, ModalFooter, Col } from 'reactstrap';
import { ModalButtonCancel, ModalButtonDelete } from '../../constant';

export const UpdateStatusAgreemet = (props) => {

    const {
        toggle, loading, name_company, contract_number, validity, saveUpdateStatus, button
    } = props;

    return (
        <Form className="theme-form pt-3" role="form" >
            <Col sm="12" className='pb-5' >
                <p className="h6 txt-danger">Deseas cambiar el estatus del convenio</p>
                <b>{`${name_company}`}</b>
                <p>¿Estás seguro de hacerlo?</p>
            </Col>

        </Form>
    )
}
